import type { ChaliceStore } from '../types';

export const selectExperiments = (state: ChaliceStore) => state.experiments;
